interface OtherInfoTabProps {
	invoice: {
		reference_number?: string | null;
		order_reference_number?: string | null;
		invoice_number?: string | null;
		invoice_date?: string | null;
		due_date?: string | null;
		start_date?: string | null;
		terms?: string | null;
		status?: string | null;
		collection_status?: string | null;
		payment_method?: string | null;
		description?: string | null;
		contract_type?: string | null;
		contract_start_date?: string | null;
		contract_end_date?: string | null;
		project_name?: string | null;
		client_id?: string | null;
		created_at?: string | null;
	};
}

export function OtherInfoTab({ invoice }: OtherInfoTabProps) {
	return (
		<dl className="grid grid-cols-1 gap-x-6 gap-y-4 pt-2 text-sm sm:grid-cols-2">
			<Field label="Reference #" value={invoice.reference_number ?? "—"} />
			<Field label="Order reference #" value={invoice.order_reference_number ?? "—"} />
			<Field label="Invoice #" value={invoice.invoice_number ?? "—"} />
			<Field label="Invoice date" value={invoice.invoice_date ?? "—"} />
			<Field label="Due date" value={invoice.due_date ?? "—"} />
			<Field label="Service start" value={invoice.start_date ?? "—"} />
			<Field label="Terms" value={invoice.terms ?? "—"} />
			<Field label="Status" value={<span className="capitalize">{invoice.status ?? "—"}</span>} />
			<Field label="Collection status" value={<span className="capitalize">{invoice.collection_status ?? "—"}</span>} />
			<Field label="Payment method" value={invoice.payment_method ?? "—"} />
			<Field label="Project" value={invoice.project_name ?? "—"} />
			<Field
				label="Contract"
				value={
					invoice.contract_type
						? `${invoice.contract_type}${
								invoice.contract_start_date && invoice.contract_end_date ? ` (${invoice.contract_start_date} → ${invoice.contract_end_date})` : ""
							}`
						: "—"
				}
			/>
			{invoice.description ? (
				<div className="sm:col-span-2">
					<Field label="Description" value={invoice.description} />
				</div>
			) : null}
		</dl>
	);
}

function Field({ label, value }: { label: string; value: React.ReactNode }) {
	return (
		<div>
			<dt className="text-xs font-medium uppercase tracking-wide text-foreground/60">{label}</dt>
			<dd className="mt-0.5 text-foreground-dark">{value}</dd>
		</div>
	);
}
